import { render, staticRenderFns } from "./EditBatchImport.vue?vue&type=template&id=21a0701d&scoped=true&"
import script from "./EditBatchImport.vue?vue&type=script&lang=js&"
export * from "./EditBatchImport.vue?vue&type=script&lang=js&"
import style0 from "./EditBatchImport.vue?vue&type=style&index=0&id=21a0701d&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a0701d",
  null
  
)

export default component.exports